<template>
  <div>
    <click-to-edit
      v-model="scope.row.scale.planned_bonus"
      :disabled="!isFieldAvailableForEdit(scope.row, 'scale.planned_bonus')"
      placeholder=""
      :number-format="{decimals: 2, space:true}"
      digits-only
      style="width: 100%"
      @input="saveElementPropChange(scope.row, 'scale', {planned_bonus:$event})"
    ></click-to-edit>
  </div>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import {variables} from "@/componentsCompany/smz/variables";
export default {
  name: 'astra-top-element-planned-bonus-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {
      scaleTypesEnum: variables.scaleTypesEnum,
    }
  },
  computed: {},
  methods: {

  }
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";

</style>
